// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cPNbqJnluPjVid {
  display: flex;
  width: 100%;
  width: fit-content;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: 35px auto;
}
`, ""]);
// Exports
export var facepileContainer = `cPNbqJnluPjVid`;
export default ___CSS_LOADER_EXPORT___;
